var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53281 15.6926C2.68281 14.5886 2.25781 14.0356 2.25781 12.3966C2.25781 10.7566 2.68281 10.2056 3.53281 9.10061C5.22981 6.89661 8.07581 4.39661 12.2578 4.39661C16.4398 4.39661 19.2858 6.89661 20.9828 9.10061C21.8328 10.2066 22.2578 10.7576 22.2578 12.3966C22.2578 14.0366 21.8328 14.5876 20.9828 15.6926C19.2858 17.8966 16.4398 20.3966 12.2578 20.3966C8.07581 20.3966 5.22981 17.8966 3.53281 15.6926Z",
    stroke: "#0F81CD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2578 12.3966C15.2578 13.1923 14.9417 13.9553 14.3791 14.5179C13.8165 15.0805 13.0535 15.3966 12.2578 15.3966C11.4622 15.3966 10.6991 15.0805 10.1365 14.5179C9.57388 13.9553 9.25781 13.1923 9.25781 12.3966C9.25781 11.601 9.57388 10.8379 10.1365 10.2753C10.6991 9.71268 11.4622 9.39661 12.2578 9.39661C13.0535 9.39661 13.8165 9.71268 14.3791 10.2753C14.9417 10.8379 15.2578 11.601 15.2578 12.3966Z",
    stroke: "#0F81CD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.6ba3f8fe6a92278dfbf69853e5ec5f44.svg";
export { ForwardRef as ReactComponent };